export default "__VITE_ASSET__WFqm9l1w__"